module.exports = __webpack_public_path__ + "img/Station Types_01.3d77e5e5.jpg";